module.exports = __webpack_public_path__ + "static/media/redux.59c46753.png";